import { Inline, Stack, Text, useDevice, useViewport } from '@treatwell/ui';
import clsx from 'clsx';
import { VenueCard, VenueCardType } from 'js/components/VenueCard/VenueCard';
import React from 'react';
import { trackVenueSelection } from '../tracking';
import styles from './VenueCardSection.module.css';

export type VenueCardSectionType = {
  renderTitle: (titleHighlightedClassName: string) => React.ReactElement;
  venueCards: VenueCardType[];
  className?: string;
};

type Props = {
  countryCode: string;
} & VenueCardSectionType;

export const VenueCardSection = ({
  renderTitle,
  venueCards,
  className,
  countryCode,
}: Props) => {
  const { isDesktop: isDesktopDevice } = useDevice();
  const isDesktop = useViewport({
    device: 'desktop',
    serverRender: isDesktopDevice,
  });

  return (
    <Stack space={isDesktop ? 'xl' : 'md'} className={clsx(className)}>
      <Text as="h2" type="lgHeader" className={styles.title}>
        {renderTitle(styles.titleHighlighted)}
      </Text>
      <Inline space="lg" className={styles.venueCards}>
        {venueCards.map((venueCard, index) => (
          <VenueCard
            key={venueCard.id}
            cardNumber={index}
            onClick={(venueId, redirectUri) => {
              trackVenueSelection(`${venueId}`).finally(() => {
                window.location.href = redirectUri;
              });
            }}
            pageName="near_me"
            countryCode={countryCode}
            {...venueCard}
          />
        ))}
      </Inline>
    </Stack>
  );
};
